import { isAuthorized, getUserId } from 'utils/Auth'
import { createReducer } from '../utils'

export const JOB_EMAIL_REQUEST = 'sherrinford/email/JOB_EMAIL_REQUEST'
export const JOB_EMAIL_SUCCESS = 'sherrinford/email/JOB_EMAIL_SUCCESS'
export const JOB_EMAIL_ERROR = 'sherrinford/email/JOB_EMAIL_ERROR'

const initialStates = {
  isSent: false,
}

export default createReducer(initialStates, {
  [JOB_EMAIL_REQUEST]: state => ({
    ...state,
    isSent: initialStates.isSent,
  }),
  [JOB_EMAIL_SUCCESS]: (state, data) => ({
    ...state,
    isSent: !initialStates.isSent,
    data,
  }),
  [JOB_EMAIL_ERROR]: state => ({
    ...state,
    isSent: initialStates.isSent,
  }),
})

export const sendJobEmail = (id) => {
  const token = JSON.parse(isAuthorized())
  const data = {
    token,
    userId: JSON.parse(getUserId()),
  }
  console.log(data)
  return {
    type: [
      JOB_EMAIL_REQUEST,
      JOB_EMAIL_SUCCESS,
      JOB_EMAIL_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: `/ps/order/${id}/send_email`,
      authorization: `${token}`,
      payloads: data,
      universeHost: true,
    },
    nextAction: res => {
      if (res.code == 400) {
        return ''
      }
      if (res.code == 200) {
        return ''
      }
    },
  }
}
